<script setup>
import Icon from '@/components/Icon.vue';

const props = defineProps({
  badge: { type: String, required: true },
  badgeIcon: { type: String, required: true },
  titlePrefix: { type: String, required: true },
  titleGradient: { type: String, required: true },
  subtitle: { type: String, required: true },
  lastUpdatedLabel: { type: String, required: true },
  updatedAt: { type: String, required: true },
  calendarIcon: { type: String, required: true },
});
</script>

<template>
  <section class="relative pt-48 pb-24 overflow-hidden px-6">
    <div
      class="absolute top-[-10%] left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#ecd79f]/15 via-[#ecd79f]/5 to-transparent blur-[80px] rounded-full pointer-events-none animate-fade-in"
    />
    <div
      class="absolute top-[10%] right-[-10%] w-[500px] h-[500px] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#1c4848]/5 to-transparent blur-[100px] rounded-full pointer-events-none"
    />

    <div
      class="max-w-3xl mx-auto text-center relative z-10 animate-slide-up"
      style="animation-delay: 0.1s;"
    >
      <div
        class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/50 backdrop-blur-sm border border-[#1c4848]/5 shadow-sm mb-8"
      >
        <Icon :icon="props.badgeIcon" class="text-[#1c4848] text-base" />
        <span class="text-xs font-medium text-[#1c4848] uppercase tracking-[0.2em]">
          {{ props.badge }}
        </span>
      </div>

      <h1
        class="text-5xl lg:text-7xl font-serif text-[#1c4848] font-medium leading-[1.05] tracking-tighter mb-8"
      >
        {{ props.titlePrefix }}
        <span class="text-gradient">{{ props.titleGradient }}</span>
      </h1>

      <p class="text-lg text-[#1c4848]/60 font-normal max-w-xl mx-auto leading-relaxed">
        {{ props.subtitle }}
      </p>

      <div class="mt-10 flex items-center justify-center gap-2 text-xs font-medium text-[#1c4848]/40 uppercase tracking-widest">
        <Icon :icon="props.calendarIcon" class="text-sm" />
        {{ props.lastUpdatedLabel }}: {{ props.updatedAt }}
      </div>

      <slot name="search" />
    </div>
  </section>
</template>

